<template>
  <div class="chatbot">
    <div class="content">
      <ChatBotCoverageResult
        v-if="message.botPayload && message.botPayload.coverageResult"
        :coverageResult="message.botPayload.coverageResult"
        :topic="message.botPayload.context.topic"
      />
      <ChatBotQuestion
        v-if="message.botPayload && message.botPayload.question && message.botPayload.question.questionId && message.botPayload.context"
        :message="message"
      />
      <ChatBotOptions
        v-if="message.botPayload && message.botPayload.question && message.botPayload.question.options"
        :botPayload="message.botPayload"
        :messageId="message.msgId"
        :botStatus="message.botStatus"
        :answer="message.botPayload.question.answer"
      />
      <ChatBotNotSupported
        v-if="message.botPayload && message.botPayload.question && message.botPayload.question.answer === 'not_supported_product'"
      />
      <template v-if="isSystemClosedConversation">
        {{ t('messages_system_closed_conversation') }}
      </template>
    </div>
  </div>
</template>

<script>
import { computed } from '@vue/composition-api'
import ChatBotQuestion from './ChatBotQuestion'
import ChatBotOptions from './ChatBotOptions'
import ChatBotCoverageResult from './ChatBotCoverageResult'
import ChatBotNotSupported from './ChatBotNotSupported'
import { useI36n } from '@jota-one/i36n/src/index.vue2'

export default {
  name: 'ChatBot',
  components: {
    ChatBotNotSupported,
    ChatBotQuestion,
    ChatBotOptions,
    ChatBotCoverageResult
  },
  props: {
    message: {
      type: Object,
      default: () => ({})
    }
  },

  setup (props) {
    const { $label: t } = useI36n()

    const isSystemClosedConversation = computed(() => {
      return props.message.botPayload && !props.message.botPayload.context && props.message.botPayload.question && props.message.botPayload.question.questionId === 'chatbot_left'
    })

    return {
      t,
      isSystemClosedConversation
    }
  }
}
</script>

<style scoped lang="postcss">
  .chatbot {
    background-color: white;
    border-radius: 15px;
  }
</style>
